import { FC } from "react";
import { IonCard, IonIcon, IonItem, IonText } from "@ionic/react";
import { mailUnreadOutline } from "ionicons/icons";
import { useTranslation } from "react-i18next";

import "./MagicLinkSuccess.css";

export interface MagicLinkSuccessProps {
    email: string;
}

export const MagicLinkSuccess: FC<MagicLinkSuccessProps> = ({ email }) => {
    const { t } = useTranslation();

    return (
        <IonCard color="transparent">
            <IonItem lines="none" color="transparent">
                <div
                    className="magic-link-success-container"
                    data-testid="magic-link-success"
                >
                    <IonIcon
                        icon={mailUnreadOutline}
                        className="magic-link-success-icon"
                    />
                    <IonText>
                        <h3 className="magic-link-success-title">
                            {t("login.login.magicLinkSuccessTitle")}
                        </h3>
                    </IonText>
                    <IonText>
                        <p className="magic-link-success-message">
                            {t("login.login.magicLinkSuccessMessage")}
                        </p>
                    </IonText>
                </div>
            </IonItem>
        </IonCard>
    );
};
